export const MOBILE_CHECKOUT_SUMMARY_VISIBLE =
  'MOBILE_CHECKOUT_SUMMARY_VISIBLE';
export const MOBILE_CHECKOUT_SUMMARY_NOT_VISIBLE =
  'MOBILE_CHECKOUT_SUMMARY_NOT_VISIBLE';
